// AUTO-GENERATED — do not edit. Run `pnpm build` in packages/domain-data.
// Source: business/ishvaram/data/commerce/report_plans.snapshot.json

import type { PremiumReportPlanId } from "./reportPlans";

/** Bundle-light display facts for acquisition CTAs. */
export interface ReportPlanSummary {
  id: PremiumReportPlanId;
  name: string;
  /** Hindi display name (falls back to `name` when the catalog has none). */
  name_hi: string;
  price_inr: number;
  pages: number;
}

export const reportPlanSummaries: readonly ReportPlanSummary[] = [
  {
    id: "brihat_kundali",
    name: "Brihat Kundali Report",
    name_hi: "बृहत् कुंडली रिपोर्ट",
    price_inr: 199,
    pages: 16,
  },
  {
    id: "career_report",
    name: "Career & Finance Report",
    name_hi: "जीविका एवं धन रिपोर्ट",
    price_inr: 149,
    pages: 28,
  },
  {
    id: "marriage_report",
    name: "Marriage & Compatibility Report",
    name_hi: "विवाह एवं अनुकूलता रिपोर्ट",
    price_inr: 149,
    pages: 10,
  },
  {
    id: "annual_forecast",
    name: "Annual Forecast",
    name_hi: "वार्षिक पूर्वानुमान",
    price_inr: 149,
    pages: 8,
  },
  {
    id: "muhurat_report",
    name: "Personal Muhurat & Sankalp Plan",
    name_hi: "व्यक्तिगत मुहूर्त एवं संकल्प योजना",
    price_inr: 149,
    pages: 17,
  },
  {
    id: "dosha_remedy_plan",
    name: "Dosha Diagnosis & Remedy Plan",
    name_hi: "दोष निदान एवं उपाय योजना",
    price_inr: 199,
    pages: 6,
  },
  {
    id: "sade_sati",
    name: "Sade Sati Personal Report",
    name_hi: "साढ़े साती व्यक्तिगत रिपोर्ट",
    price_inr: 149,
    pages: 13,
  },
  {
    id: "pitra_dosh",
    name: "Pitra Dosh Personal Report",
    name_hi: "पितृ दोष व्यक्तिगत रिपोर्ट",
    price_inr: 99,
    pages: 12,
  },
  {
    id: "mahadasha_forecast",
    name: "12-Month Mahadasha Forecast",
    name_hi: "१२ माह की महादशा भविष्यवाणी",
    price_inr: 199,
    pages: 16,
  },
  {
    id: "numerology_report",
    name: "Numerology Life Report",
    name_hi: "अंक ज्योतिष जीवन रिपोर्ट",
    price_inr: 149,
    pages: 10,
  },
  {
    id: "gemstone_report",
    name: "Rudraksha & Ratna Recommendation",
    name_hi: "रुद्राक्ष एवं रत्न अनुशंसा रिपोर्ट",
    price_inr: 199,
    pages: 12,
  },
  {
    id: "baby_name_report",
    name: "Baby Name Report",
    name_hi: "शिशु नामकरण रिपोर्ट (नक्षत्र आधारित)",
    price_inr: 199,
    pages: 12,
  },
  {
    id: "lal_kitab_report",
    name: "Lal Kitab Remedy Report",
    name_hi: "लाल किताब उपाय रिपोर्ट",
    price_inr: 149,
    pages: 12,
  },
  {
    id: "transit_forecast",
    name: "Gochar Transit Forecast",
    name_hi: "गोचर भविष्यवाणी रिपोर्ट",
    price_inr: 199,
    pages: 14,
  },
  {
    id: "mahadasha_forecast_winback",
    name: "12-Month Mahadasha Forecast",
    name_hi: "१२ माह की महादशा भविष्यवाणी",
    price_inr: 49,
    pages: 16,
  },
  {
    id: "sade_sati_winback",
    name: "Sade Sati Personal Report",
    name_hi: "साढ़े साती व्यक्तिगत रिपोर्ट",
    price_inr: 49,
    pages: 13,
  },
  {
    id: "ask_one_question",
    name: "Ask One Question",
    name_hi: "आपका एक प्रश्न",
    price_inr: 49,
    pages: 1,
  },
] as const;

export const reportPlanSummaryMap: Readonly<Record<PremiumReportPlanId, ReportPlanSummary>> =
  Object.fromEntries(reportPlanSummaries.map((plan) => [plan.id, plan])) as Record<
    PremiumReportPlanId,
    ReportPlanSummary
  >;
